import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './index.css'
import router from './router'
import store from './store'
import VueTippy from 'vue-tippy';


const app = createApp(App).use(router).use(store)
app.mount('#app')
app.use(VueAxios, axios)
app.use(VueTippy);